import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Card, CardActionArea, CardContent, Container, Grid, Typography } from "@material-ui/core";
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import { ESTADISTICAS_OSPEDYC } from "../../../utils/constants";
import { cargarEstadisticas } from "../../../actions/miOspedyc/estadisticasMiOspedyc";
import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100%',
    marginTop: "1.5rem",
    marginBottom: "1rem"
  },
  title: {
    fontWeight: "bold"
  },
  cardsHome: {
    paddingLeft: "1.5rem",
    paddingRight: "1.5rem",
    marginBottom: "2rem"
  },
  cardIn: {
    borderRadius: 10
  },
  cardActionArea: {
    padding: "1rem"
  }
}));

export const Contacto = (props) => {

  const classes = useStyles();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(cargarEstadisticas(ESTADISTICAS_OSPEDYC.CONTACTOS))
    // eslint-disable-next-line
}, [])
  return (
    <div className={classes.root}>
      <Container>
        <Typography align="center" variant="h4" color="primary" className={classes.title}>Contactos</Typography>
        <Grid
          container
          direction="row"
          alignItems="center"
          style={{ marginTop: "1rem" }}
        >
          <Grid item xs={12} sm={6} className={classes.cardsHome} component="a" href="tel:0800-345-6773" style={{ textDecoration: "none" }}>
            <Card variant="outlined" className={classes.cardIn}>
              <CardActionArea className={classes.cardActionArea}>
                <CardContent style={{ textAlign: "center" }}>
                  <Typography variant="h6" style={{ fontWeight: "bold" }} >URGENCIAS MÉDICAS</Typography>
                  <Typography variant="h5" color="primary" style={{ fontWeight: "bold" }}>0800-345-6773</Typography>
                  <Typography variant="body1" color="primary">(Opción 1)</Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} className={classes.cardsHome} component="a" href="tel:011 5365-7006 / 0810-333-0467" target="_blank" style={{ textDecoration: "none" }}>
            <Card variant="outlined" className={classes.cardIn} >
              <CardActionArea className={classes.cardActionArea}>
                <CardContent style={{ textAlign: "center" }}>
                  <Typography variant="h6" style={{ fontWeight: "bold" }} >URGENCIAS PSIQUIÁTRICAS</Typography>
                  <Typography variant="h5" color="primary" style={{ fontWeight: "bold" }}>011 5365-7006 / 0810-333-0467</Typography>
                  <Typography variant="body1" color="primary">Lunes a Viernes de 9 a 18 / FUERA DE HORARIO</Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} className={classes.cardsHome} component="a" href="tel:0800-345-6773" style={{ textDecoration: "none" }}>
            <Card variant="outlined" className={classes.cardIn}>
              <CardActionArea className={classes.cardActionArea}>
                <CardContent style={{ textAlign: "center" }}>
                  <Typography variant="h6" style={{ fontWeight: "bold" }} >CALL CENTER</Typography>
                  <Typography variant="h5" color="primary" style={{ fontWeight: "bold" }}>0800-345-6773</Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
          <Grid item xs={12} className={classes.cardsHome} component="a" href="https://api.whatsapp.com/send?phone=5491121926773" target="_blank" style={{ textDecoration: "none" }}>
            <Card variant="outlined" className={classes.cardIn} style={{backgroundColor:"#eee"}} >
              <CardContent style={{ textAlign: "center" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <WhatsAppIcon color="primary" style={{ fontSize: "2rem" }} />
                  <Typography variant="h6" color="primary" style={{ fontWeight: "bold", marginRight: "0.5rem", marginLeft: "0.5rem" }} >WhatsApp</Typography>
                  <Typography variant="h5" color="primary">+54 9 11 2192-6773</Typography>
                </div>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};
